import React from 'react';
import { Building2, ShieldCheck, Zap } from 'lucide-react';
import { portfolioData } from '../data/portfolioData';

export const Clients: React.FC = () => {
  return (
    <section className="section clients-section">
      <div className="container">
        <div className="clients-header">
          <div className="section-badge">
            <Building2 size={14} />
            <span>Trusted Enterprise Leadership</span>
          </div>
          <h2 className="section-title">
            Key Clients & <span className="text-gradient">Enterprise Partners</span>
          </h2>
          <p className="section-subtitle">
            Engineered high-scale software solutions, point-of-sale systems, and database migrations for top-tier global brands.
          </p>
        </div>

        <div className="clients-grid">
          {portfolioData.clients.map((client, index) => (
            <div key={index} className="client-card glass-card">
              <div className="client-card-top">
                <div className="client-logo-badge">
                  <ShieldCheck size={20} />
                </div>
                <span className="client-badge-pill">{client.badge}</span>
              </div>

              <h3 className="client-name">{client.name}</h3>
              <span className="client-category">{client.category}</span>

              <div className="client-impact">
                <Zap size={14} className="zap-icon" />
                <span>{client.impact}</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        .clients-section {
          background: var(--bg-primary);
          border-bottom: 1px solid var(--border-color);
          padding-top: 4rem;
          padding-bottom: 4rem;
        }

        .clients-header {
          text-align: center;
          max-width: 720px;
          margin: 0 auto 3rem auto;
        }

        .clients-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
          gap: 1.5rem;
        }

        .client-card {
          padding: 1.75rem;
          display: flex;
          flex-direction: column;
          gap: 0.75rem;
          position: relative;
          transition: transform 0.3s ease, border-color 0.3s ease;
        }

        .client-card:hover {
          transform: translateY(-5px);
          border-color: var(--border-highlight);
          box-shadow: var(--shadow-glow);
        }

        .client-card-top {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 0.5rem;
        }

        .client-logo-badge {
          width: 42px;
          height: 42px;
          border-radius: var(--radius-sm);
          background: var(--gradient-glow);
          border: 1px solid var(--border-highlight);
          color: var(--accent-primary);
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .client-badge-pill {
          padding: 0.25rem 0.75rem;
          border-radius: var(--radius-full);
          background: rgba(6, 182, 212, 0.1);
          border: 1px solid rgba(6, 182, 212, 0.25);
          color: var(--accent-secondary);
          font-size: 0.78rem;
          font-weight: 700;
        }

        .client-name {
          font-size: 1.3rem;
          font-weight: 800;
          color: var(--text-main);
          letter-spacing: -0.01em;
        }

        .client-category {
          font-size: 0.85rem;
          color: var(--text-dim);
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.05em;
        }

        .client-impact {
          display: flex;
          align-items: center;
          gap: 0.4rem;
          margin-top: 0.5rem;
          padding-top: 0.85rem;
          border-top: 1px dashed var(--border-color);
          font-size: 0.9rem;
          color: var(--text-muted);
          font-weight: 500;
        }

        .zap-icon {
          color: var(--accent-secondary);
          flex-shrink: 0;
        }

        @media (max-width: 768px) {
          .clients-grid {
            grid-template-columns: 1fr;
          }
        }
      `}</style>
    </section>
  );
};
